<template>
    <div class="h-100 w-100">
        <app-loader v-if="appLoading" variant="bq-green" />
        <b-container v-if="!appLoading" >

            <b-row class="parts-nav__header">
                <b-col cols="8">
                    <span v-if="!logoHidden">
                        <logo class="mt-3" :whitelabel-config="whitelabelConfig" />
                    </span>
                </b-col>
                <b-col>
                    <indicator-ball class="parts-nav__progress d-flex justify-content-end">
                        <div class="d-flex align-items-center">
                            {{ interactionProgressTotal }}
                            <div class="parts-nav__progress-percent">%</div>
                        </div>
                    </indicator-ball>
                </b-col>
            </b-row>

            <b-row class="parts-nav__nav d-flex flex-column">
                <b-col cols="12" lg="8" class="mx-lg-auto">
                    <intermediate-navigation
                        :items="parts"
                        :isLoading="isLoading"
                        :navigationInProgress="navigationInProgress"
                        @click="handleClick"
                    />
                </b-col>
            </b-row>

        </b-container>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { HIDDEN_ITEM, LOGO_HIDDEN } from '@/constants/items'
import indicatorBall from '@/components/ui/indicatorBall'
import intermediateNavigation from '@/components/ui/intermediateNavigation'
import logo from '@/components/ui/logo'

export default {
    name: 'NavigationContainer',
    components: {
        'intermediate-navigation': intermediateNavigation,
        'indicator-ball': indicatorBall,
        logo
    },
    props: {
        interactionInstanceToken: {
            type: String
        }
    },
    data() {
      return {
        navigationInProgress: false,
      }
    },
    computed: {
        ...mapGetters([
            'appLoading',
            'interactionProgressTotal',
            'currentItemNumber',
            'currentItem',
            'partItems',
            'instanceToken',
            'isLoading',
            'whitelabelConfig'
        ]),
        parts() {
            let activeSet = false

            return this.partItems.map((item, i) => {
                if(!activeSet) {
                    // we set all parts to visited until active part is found
                    activeSet = this.currentItem.itemId === item.itemId
                }

                return {
                    itemId: item.itemId,
                    active: this.currentItem.itemId === item.itemId,
                    visited: !activeSet,
                    content: this.$t(item.text),
                    variant: item.variant
                }
            })
        },
        logoHidden() {
            return !!this.currentItem?.properties?.find(prop => prop.name === LOGO_HIDDEN);
        }
    },
    methods: {
        ...mapActions([
            'answerItem',
            'setCurrentItemNumber',
            'setColorVariant'
        ]),
        async handleClick(part) {
            this.navigationInProgress = true;
            await this.answerItem({
                interactionInstanceToken: this.instanceToken,
                itemId: this.currentItem.itemId,
                answer: { result: 1 }
            }).then(() => {
              this.setColorVariant(part.variant)
              this.setCurrentItemNumber({ number: this.currentItemNumber + 1 });
              this.navigationInProgress = false;
            }).catch(() => {
              this.navigationInProgress = false;
            });

        }
    },
    mounted() {
        const isHidden = this.currentItem && this.currentItem.properties && this.currentItem.properties.find(prop => prop.name === HIDDEN_ITEM)
        if(isHidden) {
            this.answerItem({
                interactionInstanceToken: this.instanceToken,
                itemId: this.currentItem.itemId,
                answer: { result: 1 }
            });

            this.setCurrentItemNumber({ number: this.currentItemNumber + 1 });
        }
    }
}
</script>
<style lang="scss">
    .parts-nav__header {
        flex-wrap: nowrap;
        @media screen and (max-width: 567px) {
            overflow: hidden;
        }

        @media screen and (min-width: 992px) {
            padding: 0 150px;
        }
    }

    .parts-nav__progress {
        position: relative;
        top: -27px;
        font-size: 1.75em;
        transform: scale(1.2);
        z-index: 3000;
        @media screen and (max-width: 768px) {
            right: -27px;
        }
    }

    .parts-nav__progress-percent {
        font-size: 0.625em;
    }

    .parts-nav__nav {
        @media screen and (max-width: 768px) {
            margin-top: -25px;
        }
    }

    .parts-navigation__part {
        font-size: 0.875em;
        line-height: 1em;
    }

    .parts-navigation__part-name {
        font-size: 1.125em;
        font-weight: 600;
    }


</style>
